<template>
    <div class="web_notice" ref="bbbbb" v-if="showModal">
        <div class="Bt">
            <h3 style="font-weight: bold;text-align: center;font-size: 30px;
    ">点击放大图片</h3>
            <div style="font-weight: bold;text-align: center;font-size: 30px;">
                <viewer ref="imgref" :images="anliList">
                    <img :src="WcImgValue" @click="godi"  style="width: 300px; height: 300px; cursor: pointer;">
                </viewer>
            </div>
            <a style="display: block;background: #98a3ff;color: #FFF;text-align: center;font-weight: bold;font-size: 19px;line-height: 60px;margin: 0 auto;margin-top: 45px;border-radius: 32px;width: 80%;"
                class="but" @click="resetFirst">退出</a>
        </div>
    </div>
</template>
<script>

export default {
    name: "dragModal",
    components: {},
    data() {
        return {
            showModal: false, //是否打开弹窗 非0打开
            left: "",
            top: "",
            direction: 'rtl',
            activeIndex: 1,
            connection: null,
            msgs: [],
            dataInfo: { status1: "off", status2: "off" },
            anliList: [],
            WcImgValue: '',

        };
    },
    props: {


    },

    computed: {},


    methods: {


        resetFirst() {
            this.showModal = false
        },
        show(url) {
            this.showModal = true
            this.WcImgValue = url
             this.$refs.bbbbb.style.display='block'
        },
        godi(){
            this.$refs.bbbbb.style.display='none'
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="less" scoped>
/deep/ .el-dialog {
    position: absolute;
    /* right: 0; */
    left: 76vw;
    /* bottom: 100px; */

}

.el-menu-demo .el-menu-item,
.el-submenu__title {

    height: 35px;
    line-height: 35px;
}

.el-menu-demo {
    padding: 0 20px;
}

//图片
.left_image {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 10px;
    margin-top: -20px;
    border-radius: 50%;
}

//每一条
.notification_text {
    width: 100%;
    height: 80px;
    border-bottom: 1px #ccc solid;
    position: relative;
}

//底部按钮
.bottom_button {
    width: 330px;
    height: 50px;
    border-top: #ccc 1px solid;
    position: absolute;
    bottom: 0;
    left: 0;
}

//左右按钮
.bottom_button_left,
.bottom_button_right {
    display: inline-block;
    width: 164px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
}

//左按钮
.bottom_button_left {
    border-right: solid 1px #ccc;
}

//左按钮
.bottom_button_left:hover {
    color: #40aaf7;
}

//右按钮
.bottom_button_right:hover {
    color: #40aaf7;
}

//文字部分位置
.text {
    display: inline-block;
    position: absolute;
    top: 5px;
    left: 65px;
}

//内容部分超出隐藏，给滚动条
.box {
    overflow: auto;
    height: 400px;
    /* margin-bottom: 37px; */
}

//滚动条的样式
::-webkit-scrollbar {
    //滚动条宽高
    width: 5px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    //滚动条颜色和圆角
    background-color: #dbd9d9;
    border-radius: 3px;
}

/* /deep/ .el-dialog__header {
        background-color: #db7b3f !important;
        padding-bottom: 16px !important;
    } */

.title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin: 10px 0;

}

.time {
    text-align: right;
    color: f9f9f9;
    margin-bottom: 10px;
    margin-right: 10px;
}

.btn {
    background-color: #40aaf7;
    border: none;
    display: flex;
    align-items: center;
    margin: auto;
    font-size: 16px;
    width: 100px;
    height: 36px;
    margin-bottom: 10px;
    text-align: center;
}

.web_notice {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99999;
}

.Bt {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 550px;
    background: #FFF;
    transform: translate(-50%, -50%);
    border-radius: 40px;
    padding: 50px 40px;
}




</style>